import { render, staticRenderFns } from "./event-container.vue?vue&type=template&id=5798f0a1&"
import script from "./event-container.vue?vue&type=script&lang=js&"
export * from "./event-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports